import React, { useCallback } from 'react';
import {Accept, useDropzone} from 'react-dropzone';
import {useTranslation} from "react-i18next";
import {Dropzone, FeedbackTotalAttached, MultiUploadAreaContainer, PreviewFile} from "./styles";
import {ReactComponent as UploadIcon} from '../../assets/icons/drag_upload_icon.svg';
import {ReactComponent as CloseRounded} from "../../assets/icons/close_rounded.svg";
import {downloadBase64File} from "../../utils/constants";

// Define the types for the props
interface MultiUploadAreaProps {
    files: { base64: string; file_name:string }[];
    setFiles: React.Dispatch<React.SetStateAction<{ base64: string; file_name: string }[]>>;
    accept: Accept;
}

const MultiUploadArea: React.FC<MultiUploadAreaProps> = ({ files, setFiles, accept}) => {
    const {t} = useTranslation()
    // Function to convert files to base64
    const fileToBase64 = (file: File, callback: (result: string | ArrayBuffer | null) => void) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => callback(reader.result);
        reader.onerror = (error) => console.error('Error: ', error);
    };

    // Callback function for handling file drops or selections
    const onDrop = useCallback((acceptedFiles: File[]) => {
        acceptedFiles.forEach((file) => {
            fileToBase64(file, (base64) => {
                const newFile = {
                    base64: base64 as string, // Type assertion to treat base64 as string
                    file_name: file.name,
                };
                setFiles((prevFiles) => [...prevFiles, newFile]);
            });
        });
    }, [setFiles]);

    // Use the useDropzone hook with accepted file types
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept
    });

    const handleRemoveDocument = (index: number) => {
        setFiles(files.filter((_, fileIndex) => fileIndex !== index));
    }

    return (
        <MultiUploadAreaContainer>
            <div>{files.map((file, index) => {
                return <PreviewFile key={index}>
                    <button className="download" onClick={() => downloadBase64File(file.base64, file.file_name)}>
                        {file.file_name}
                    </button>
                    <button className="remove" onClick={() => handleRemoveDocument(index)}>
                        <CloseRounded/>
                    </button>
                </PreviewFile>
            })}
            </div>
            <FeedbackTotalAttached>
                {t(
                    files.length ? 'total_files_attached' : 'no_files_attached',
                    {total: files.length}
                )}
            </FeedbackTotalAttached>
            <Dropzone {...getRootProps()} isDragActive={isDragActive}>
                <input {...getInputProps()} />
                <div><UploadIcon/></div>
                <p>{t('drop_files')}</p>
            </Dropzone>
        </MultiUploadAreaContainer>
    );
};

export default MultiUploadArea;
